(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hm-brand-style"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('.product-form__submit');
    if (!button || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      document.body.classList.toggle('hm-purchase-in-view', entries.some(entry => entry.isIntersecting));
    });
    observer.observe(button);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hm-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('hm-newsletter-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const launcher = document.querySelector('[data-hm-newsletter-open]');
    const key = 'hm-newsletter-dismissed';
    const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
    const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
    launcher?.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-hm-newsletter-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', remember);
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    if (dialog.querySelector('[data-hm-newsletter-success], [data-hm-newsletter-errors]')) {
      dialog.showModal();
      if (dialog.querySelector('[data-hm-newsletter-success]')) { remember(); if (launcher) launcher.hidden = true; }
      return;
    }
    const attemptOpen = () => {
      if (dismissed() || dialog.open) return;
      const cookieBanner = document.getElementById('shopify-pc__banner');
      if (document.querySelector('dialog[open]') || (cookieBanner && cookieBanner.getBoundingClientRect().height > 0)) {
        window.setTimeout(attemptOpen, 5000);
        return;
      }
      dialog.showModal();
    };
    if (!window.matchMedia('(max-width: 749px)').matches) window.setTimeout(attemptOpen, 12000);
  })();
  } catch(e) { console.error(e); }
})();

})();
